import { render } from "./CookieBanner.vue?vue&type=template&id=ba3828f8"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CookieBanner.vue?vue&type=style&index=0&id=ba3828f8&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.13_webpack@5.105.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__